import { render, staticRenderFns } from "./pageColorPicker.vue?vue&type=template&id=24971e2f&scoped=true&"
import script from "./pageColorPicker.vue?vue&type=script&lang=js&"
export * from "./pageColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./pageColorPicker.vue?vue&type=style&index=0&id=24971e2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24971e2f",
  null
  
)

export default component.exports